/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Store } from '@ngxs/store';
import { env } from '../../../environments/environment-factory';
import { OAuthService } from 'angular-oauth2-oidc';
import { concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthState } from './state/authState.state';

export function csJwtOptionsProvider(store: Store, oauthService: OAuthService) {
    const apiBase = new URL(env.apiBase);
    const baseHref = env.baseHref === '/' ? '' : env.baseHref;
    const apiDomain = apiBase.host;
    return {
        tokenGetter: () => store
            .selectOnce(AuthState.activeMethod)
            .pipe(
                concatMap((activeMethod) => activeMethod === 'oidc'
                    ? of(oauthService.getAccessToken())
                    : store.selectOnce(AuthState.token))
            ).toPromise(),
        allowedDomains: [apiDomain],
        disallowedRoutes: [
            `${baseHref}/assets`,
            `${env.apiBase}/api/config`,
            `${env.apiBase}/api/auth/login`,
            `${env.apiBase}/api/auth/logout`,
        ],
    };
}
